import React from 'react';
import BaseCard from './BaseCard';
import Chart from 'react-apexcharts';
import './FinancialCard.scss';

const FinancialCard = ({ graphData }) => {
  const defaultOptions =  {
    chart: {
      type: "donut",
    },
    labels: ["Paid", "Unpaid"],
    colors: ["#28C76F", "#A9E9C5"],
    responsive: [
       {
        breakpoint: 1300,
        options: { chart: { height: 257 } }
      },
      {
        breakpoint: 1200,
        options: { chart: { height: 276 } }
      },
      {
        breakpoint: 1050,
        options: { chart: { height: 250 } }
      }
    ],
    legend: {
      position: "bottom",
    },
    plotOptions: {
      pie: {
        customScale: 0.9,
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              offsetY: 25,
              fontSize: "0.875rem",
              color: "#000000",
            },
            value: {
              offsetY: -15,
              fontWeight: 500,
              fontSize: "24px",
              formatter: (value) => `${value}`,
              color: "#000000",
            },
            total: {
              show: true,
              fontSize: "0.875rem",
              label: "Total Invoices",
              formatter: (value) =>
                `${value.globals.seriesTotals.reduce(
                  (total, num) => total + num
                )}`,
            },
          },
        },
      },
    },
  }
  const series = graphData?.financial?.series || [0, 0];
  const hasData = series.some(value => value > 0);

  if (!hasData) {
    return (
      <BaseCard 
        title="Patient Financial Information"
        className="financial-card"
      >
        <div className="financial-card__no-data">
          No Data
        </div>
      </BaseCard>
    );
  }

  return (
    <BaseCard 
      title="Patient Financial Information"
      className="financial-card"
    >
      <div className="financial-card__content">
        <div className="financial-card__chart">
          <Chart
            options={defaultOptions}
            series={series}
            type="donut"
          />
        </div>
      </div>
    </BaseCard>
  );
}

export default React.memo(FinancialCard); 